import React, { Component, lazy, Suspense } from 'react';
import { Routes, Route, Switch, useHistory } from "react-router-dom";
import Auth from "../../../../Layout/Auth";
import AppLandingPage from "../../../../GlobalModules/Login/Pages/AppLandingPage";
const HomePage = lazy(() => import('../Pages/HomePage'))
import SearchPage from "../Pages/SearchPage";
import NotFound from "../../../../Utility/Pages/NotFound";
import HotelDetails from "../Pages/HotelDetails";
import ComingSoonPage from "../../../../Utility/Pages/ComingSoonPage";
import TourList from "../Pages/TourList";
import TourDetails from "../Pages/TourDetails";
import PropertyTypeList from "../Pages/PropertyTypeList";
import FolioHistory from "../../Booking/Pages/FolioHistory";

function HomeRoute({ isLoggedIn, ...routeProps }) {
    const history = useHistory();
    return (
        <Switch>
            {/* applanding page route */}
            <Route
                exact
                path="/"
                render={() => (
                    <Auth history={history}>
                        <AppLandingPage history={history} />
                    </Auth>
                )}
            />
            {/* home page route */}
            <Route
                exact
                path="/:lng/home"
                render={() => (
                    <Auth history={history} allowedRoles={[]}>
                        <Suspense>
                            <HomePage isLoggedIn={isLoggedIn} history={routeProps.history} />
                        </Suspense>

                    </Auth>
                )}
            />
            {/* booking search page route */}
            <Route
                exact
                path="/:lng/search/:location?/:type?"
                render={() => (
                    <Auth history={history} allowedRoles={[]}>
                        <Suspense>
                            <SearchPage isLoggedIn={isLoggedIn} history={routeProps.history} />
                        </Suspense>

                    </Auth>
                )}
            />
            {/* not found page route */}
            <Route
                exact
                path="/:lng/notfound"
                render={() => (
                    <Auth history={history} allowedRoles={[]}>
                        <Suspense>
                            <NotFound history={history} />
                        </Suspense>

                    </Auth>
                )}
            />
            {/* hotel details page route */}
            <Route
                exact
                path="/:lng/property-details/:slug"
                render={() => (
                    <Auth history={routeProps.history} allowedRoles={['customer']}>
                        <Suspense>
                            <HotelDetails isLoggedIn={isLoggedIn} history={routeProps.history} />
                        </Suspense>

                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/tour-details/:slug"
                render={() => (
                    <Auth history={routeProps.history} allowedRoles={['customer']}>
                        <Suspense>
                            <TourDetails isLoggedIn={isLoggedIn} history={routeProps.history} />
                        </Suspense>

                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/tour-list"
                render={() => (
                    <Auth history={history} allowedRoles={['customer']}>
                        <Suspense>
                            <TourList history={routeProps.history} />
                        </Suspense>

                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/property-type-list"
                render={() => (
                    <Auth history={history} allowedRoles={['customer']}>
                        <Suspense>
                            <PropertyTypeList history={routeProps.history} />
                        </Suspense>

                    </Auth>
                )}
            />
            <Route
                exact
                path="/:lng/folio-history"
                render={() => (
                    <Auth history={history} allowedRoles={['customer']}>
                        <Suspense>
                            <FolioHistory history={routeProps.history} />
                        </Suspense>

                    </Auth>
                )}
            />
            {/* coming soon page route */}
            <Route
                exact
                path="/:lng/comingsoon"
                render={() => (
                    <Auth history={history} allowedRoles={[]}>
                        <Suspense>
                            <ComingSoonPage history={history} />
                        </Suspense>

                    </Auth>
                )}
            />

        </Switch>
    );
}

export default HomeRoute;
